export const meta = {
  title: 'Soalan lazim',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'troubleshooting'],
};

Soalan yang benar-benar ditanya pengendali, dengan jawapan ringkas. Setiap satu merujuk kembali kepada artikel lebih penuh dalam manual ini.

## Berapa lama untuk mula beroperasi?

Beberapa minit. Pendaftaran hanya empat medan tanpa kad, wizard aluan menyediakan outlet, waktu, dan logo anda, dan **Cetak QR** memberikan kod untuk diimbas pelanggan. Panduan penuh ada dalam _Bermula_. 14 hari pertama anda ialah percubaan percuma dengan akses penuh.

## Perlukah pelanggan saya memuat turun aplikasi?

Tidak. Mereka mengimbas QR anda dan aplikasi anda terbuka dalam pelayar — tiada kedai aplikasi, tiada muat turun. Mereka _boleh_ menambahnya ke skrin utama supaya berkelakuan seperti aplikasi terpasang, tetapi semuanya berfungsi tanpa itu pun.

## Nama siapa yang pelanggan nampak — saya atau rangkaian?

Anda. Nama anda, logo anda, warna anda. Rangkaian hanya muncul sebagai baris kecil "sebahagian daripada rangkaian". Lihat _Penjenamaan_.

## Apa berlaku apabila percubaan tamat?

Pelan anda mula dibilkan bulanan, secara tertunggak: satu invois tiba sejurus selepas 1 hb meliputi bulan yang baru berakhir, dan anda membayarnya melalui FPX dari halaman Bil. Setiap caj diperincikan — lihat _Bil & langganan anda_.

## Boleh saya jalankan beberapa outlet di bawah satu akaun?

Ya. Tambah outlet dari halaman Outlet; setiap satu mendapat barisan dan kod QR sendiri, dan caj prorata dipratonton sebelum anda sahkan. Kakitangan boleh diskopkan ikut outlet.

## Adakah pelanggan walk-in mengumpul mata kesetiaan?

Hanya pelanggan log masuk yang layak — tiket walk-in tanpa akaun pelanggan tidak mendapat apa-apa. Itulah sebab terbaik menggalakkan pelanggan tetap mengimbas QR anda. Lihat _Kesetiaan_.

## Kenapa siaran saya mencapai kurang orang daripada bilangan pelanggan saya?

Tiga pintu perlindungan: penarikan diri pemasaran, waktu senyap, dan pelanggan yang tidak pernah membenarkan notifikasi. Ringkasan penghantaran menamakan setiap kategori supaya jurang itu tidak menjadi misteri. Lihat _Siaran pemasaran_.

## Adakah kod ejen mengenakan sebarang kos kepada saya?

Tidak. Harga serupa dengan atau tanpanya. Ejen memperoleh komisen sekali sahaja bagi setiap pendaftaran dari pihak rangkaian — tidak sekali-kali dari bil anda. Lihat _Kod ejen & rujukan_.

## Boleh pelanggan melihat harga saya tanpa menempah?

Ya — pakej, tambahan, dan harga anda adalah umum dalam aplikasi anda. Sesiapa dengan pautan atau QR anda boleh melayari katalog sebelum membuat keputusan.

## Bahasa apa yang platform ini tuturkan?

Papan pemuka, aplikasi pelanggan anda, dan manual ini berjalan dalam English, Bahasa Melayu, 中文, dan தமிழ் — pelanggan memilih bahasa dalam aplikasi. Satu jurang jujur: teks notifikasi tolak buat masa ini tetap dalam bahasa Inggeris. Lihat _Notifikasi_.

## Adakah setiap kakitangan mendapat log masuk sendiri?

Ya. Jemput mereka melalui nombor telefon dari halaman Kakitangan dan mereka log masuk dengan kod sekali guna — tiada kata laluan untuk diurus. Peranan (pengurus, juruwang, pencuci) mengawal apa yang boleh disentuh setiap orang. Lihat _Kakitangan & peranan_.

## Bagaimana outlet saya masuk ke direktori awam?

Hidupkan **Papar outlet saya di direktori awam** di bahagian bawah halaman Waktu. Ia mati secara lalai — tiada siapa disenaraikan tanpa memilihnya sendiri. Jika sudah dihidupkan tetapi masih tidak muncul, _Penyelesaian masalah_ ada senarai semaknya.
